module.exports = __webpack_public_path__ + "img/background.56f63bbc.jpg";